import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import RadioMarker from './RadioMarker';


class Radio extends Component {
  handleChange = event => {
    const { field: { name }, radioValue, form: { setFieldValue } } = this.props;

    setFieldValue(name, radioValue);
  }

  render() {
    const { field, form, placeholder, readOnly, disabled, className, radioValue } = this.props;

    const error = form.errors[field.name];
    const hasValue = field.value != null && field.value !== '';

    return (
      <label className={classNames(`field field-checkbox`, {
        'field--disabled': disabled,
      })}>
        <input
          type='radio'
          {...field}
          disabled={disabled}
          onChange={this.handleChange}
        />
        <RadioMarker isChecked={radioValue === field.value} />
        <div className="checkbox__title">
          {placeholder}
        </div>
      </label>
    );
  }
}

Radio.propTypes = {
  containerClassName: PropTypes.string,
}

Radio.defaultProps = {
  containerClassName: '',
  inputClassName: '',
}

export default Radio;